<template>
    <div>
        <el-carousel
            v-if="list.length > 1"
            height="2.98rem"
            :interval="5000"
            arrow="always">
            <el-carousel-item v-for="item in list" :key="item.id">
                <div class="inner">
                    <img :src="item.imgUrl" draggable="false"/>
                    <span class="title" :style="getTitleStyle(item)">
                        {{ $getConfigText(item.title) }}
                    </span>
                    <div v-if="item.isButton"
                        class="btn"
                        :style="getBtnStyle(item)"
                        @click="onJump(item.buttonJumpUrl)">
                        {{ $getConfigText(item.buttonText) }}
                    </div>
                </div>
            </el-carousel-item>
        </el-carousel>
        <div class="inner" v-if="list.length === 1">
            <img :src="list[0].imgUrl" draggable="false"/>
            <span class="title" :style="getTitleStyle(list[0])">
                {{ $getConfigText(list[0].title) }}
            </span>
            <div v-if="list[0].isButton"
                class="btn"
                :style="getBtnStyle(list[0])"
                @click="onJump(list[0].buttonJumpUrl)">
                {{ $getConfigText(list[0].buttonText) }}
            </div>
        </div>
    </div>
    
</template>

<style scoped>
.inner{
    position: relative;
}
img{
    width: 100%;
    display: block;
}
.title{
    position: absolute;
    top: 32%;
    left: 0;
    right: 0;
    margin: 0 auto;
    text-align: center;
    color: #fff;
    height: 55px;
    line-height: 55px;
    font-size: 54px;
    text-shadow: 1px 1px 4px #000;
    font-weight: 450;
}
.summary{
    position: absolute;
    top: 55%;
    left: 0;
    right: 0;
    margin: 0 auto;
    text-align: center;
    color: #fff;
    font-size: 25px;
    text-shadow: 1px 1px 1px #000;
}
.btn{
    position: absolute;
    top: 75%;
    left: 0;
    right: 0;
    margin: 0 auto;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 140px;
    height: 40px;
    background-color: #0099ff;
    border-radius: 5px;
    padding: 5px 10px;
    color: #fff;
    font-size: 16px;
    cursor: pointer;
    user-select: none;
}
</style>

<script>
export default {
    props: {
        list: Array
    },
    methods: {
        onJump(link){
            window.open(link)
        },
        getTitleStyle(btnForm){
            return `color: ${btnForm.titleColor}`
        },
        getBtnStyle(btnForm){
            return `background:${btnForm.buttonColor};` +
            `color:${btnForm.buttonTextColor}`
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/common/banner-carousel.vue